import { RoleName } from '../../../types'

export const isDashboardCompanyManagerOrHrbp = (roles: RoleName[]): boolean =>
  roles.includes(RoleName.CompanyManager) || roles.includes(RoleName.BusinessPartner)

export const isHrRestrictedUser = (roles: RoleName[]): boolean => roles.some((role) => role.includes('HR_RESTRICTED'))

export const getDashboardEmptyMessageKey = (roles: RoleName[]): string => {
  if (isDashboardCompanyManagerOrHrbp(roles)) {
    return 'dashboard.empty.messageCompanyManagerOrHrbp'
  }
  if (isHrRestrictedUser(roles)) {
    return 'dashboard.empty.messageHrRestricted'
  }
  return 'dashboard.empty.messageHr'
}
